/**
 * --------------------------------------------------------
 * VDB Framework
 * The Automotive Intelligence Layer for Shopify
 *
 * Module  : Storage
 * Version : 1.0.0
 * Build   : 002
 * Commit  : 002.1
 * Schema  : Storage v2
 * --------------------------------------------------------
 */
(function (window) {
  "use strict";

  const VDB = window.VDB = window.VDB || {};
  const STORAGE_SCHEMA_VERSION = 2;

  function config() {
    const value = window.VDBConfig || {};
    return { storageKey: value.storageKey || "vdb.vehicle", storageSchemaVersion: STORAGE_SCHEMA_VERSION };
  }

  function emitError(source, error) {
    if (VDB.events && VDB.eventNames && VDB.eventNames.ERROR) {
      VDB.events.emit(VDB.eventNames.ERROR, { source: source, error: error });
    }
  }

  VDB.storage = {
    schemaVersion: STORAGE_SCHEMA_VERSION,
    get: function (key) {
      try {
        const raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        emitError("storage.get", error);
        return null;
      }
    },
    set: function (key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch (error) {
        emitError("storage.set", error);
        return false;
      }
    },
    remove: function (key) {
      try {
        window.localStorage.removeItem(key);
        return true;
      } catch (error) {
        emitError("storage.remove", error);
        return false;
      }
    },
    loadVehicle: function () {
      const c = config();
      const stored = this.get(c.storageKey);
      if (!stored) return null;
      if (typeof stored === "object" && stored.vehicle && (stored.schemaVersion === 1 || stored.schemaVersion === 2)) return stored.vehicle;
      if (typeof stored === "object" && (stored.versionId || stored.vdb_version_id)) return stored;
      return null;
    },
    saveVehicle: function (vehicle) {
      const c = config();
      return this.set(c.storageKey, { schemaVersion: STORAGE_SCHEMA_VERSION, savedAt: new Date().toISOString(), vehicle: vehicle });
    },
    clearVehicle: function () { return this.remove(config().storageKey); }
  };
})(window);
